import React from 'react';
import { useDeferredMedia } from '../hooks/useDeferredMedia';

// Native <img> with identical props, but `src` is omitted until the element
// nears the viewport — native lazy loading alone still prefetches generously.
// Callers must reserve geometry via width/height/CSS so deferral never shifts
// layout.
const DeferredScreenshot: React.FC<React.ImgHTMLAttributes<HTMLImageElement>> = ({
  src,
  srcSet,
  alt,
  ...rest
}) => {
  const { ref, shouldLoad } = useDeferredMedia<HTMLImageElement>();
  return (
    <img
      ref={ref}
      src={shouldLoad ? src : undefined}
      srcSet={shouldLoad ? srcSet : undefined}
      alt={alt}
      {...rest}
    />
  );
};

export default DeferredScreenshot;
